<style scoped lang="scss">
    @mixin adapt-width{
        min-width:1104px;
        max-width:1440px;
    }
    .stepHeaderTop{
        width:100%;
        background: #FFFFFF;
        box-shadow: 0px 1px 0px 0px #F2F3F3;
        border-bottom: 1px solid #F2F3F3;
        .stepHeaderInner{
            height:80px;
            @include adapt-width();
            display: flex;
            justify-content: center;
            margin:0 auto;
            .stepColumn{
                display:flex;
                align-items:center;
                >div{
                    width: 164px;
                    height: 80px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    background: url(~@/assets/img/initiate/arrow@2x.png) no-repeat center right;
                    background-size:contain;
                    cursor:pointer;
                    margin-left:-17px;
                    &:hover{
                        .icon{
                            &.step1{
                                background: url(~@/assets/img/initiate/step1_active.png) no-repeat center;
                                background-size:contain;
                            }
                            &.step2{
                                background: url(~@/assets/img/initiate/step2_active.png) no-repeat center;
                                background-size:contain;
                            }
                            &.step3{
                                background: url(~@/assets/img/initiate/step3_active.png) no-repeat center;
                                background-size:contain;
                            }
                            &.step4{
                                background: url(~@/assets/img/initiate/step4_active.png) no-repeat center;
                                background-size:contain;
                            }
                            &.step5{
                                background: url(~@/assets/img/initiate/step5_active.png) no-repeat center;
                                background-size:contain;
                            }
                            &.step6{
                                background: url(~@/assets/img/initiate/step6_active.png) no-repeat center;
                                background-size:contain;
                            }
                            &.step7{
                                background: url(~@/assets/img/initiate/step7_active.png) no-repeat center;
                                background-size:contain;
                            }
                        }
                    }
                    &.active{
                        background: url(~@/assets/img/initiate/bg_2@2x.png) no-repeat center;
                        background-size:contain;
                    }
                    &:first-child{
                        &.active{
                            background: url(~@/assets/img/initiate/bg_1@2x.png) no-repeat center;
                            background-size:contain;
                        }
                    }
                    &:last-child{
                        background:none;
                        &.active{
                            background: url(~@/assets/img/initiate/bg_3@2x.png) no-repeat center;
                            background-size:contain;
                        }
                    }
                    p{
                        font-size:16px;
                        color:#7A8087;
                        font-weight: 400;
                        &.active{
                            color:#222C37;
                            font-weight: 600;
                        }
                    }
                    .icon{
                        width:40px;
                        height:40px;
                        margin-bottom:4px;
                        &.step1{
                            background: url(~@/assets/img/initiate/step1.png) no-repeat center;
                            background-size:contain;
                            &.active{
                                background: url(~@/assets/img/initiate/step1_active.png) no-repeat center;
                                background-size:contain;
                            }
                        }
                        &.step2{
                            background: url(~@/assets/img/initiate/step2.png) no-repeat center;
                            background-size:contain;
                            &.active{
                                background: url(~@/assets/img/initiate/step2_active.png) no-repeat center;
                                background-size:contain;
                            }
                        }
                        &.step3{
                            background: url(~@/assets/img/initiate/step3.png) no-repeat center;
                            background-size:contain;
                            &.active{
                                background: url(~@/assets/img/initiate/step3_active.png) no-repeat center;
                                background-size:contain;
                            }
                        }
                        &.step4{
                            background: url(~@/assets/img/initiate/step4.png) no-repeat center;
                            background-size:contain;
                            &.active{
                                background: url(~@/assets/img/initiate/step4_active.png) no-repeat center;
                                background-size:contain;
                            }
                        }
                        &.step5{
                            background: url(~@/assets/img/initiate/step5.png) no-repeat center;
                            background-size:contain;
                            &.active{
                                background: url(~@/assets/img/initiate/step5_active.png) no-repeat center;
                                background-size:contain;
                            }
                        }
                        &.step6{
                            background: url(~@/assets/img/initiate/step6.png) no-repeat center;
                            background-size:contain;
                            &.active{
                                background: url(~@/assets/img/initiate/step6_active.png) no-repeat center;
                                background-size:contain;
                            }
                        }
                        &.step7{
                            background: url(~@/assets/img/initiate/step7.png) no-repeat center;
                            background-size:contain;
                            &.active{
                                background: url(~@/assets/img/initiate/step7_active.png) no-repeat center;
                                background-size:contain;
                            }
                        }
                    }
                }
            }
        }
    }
    .step_name{
        min-width:1040px;
        height:104px;
        font-size:24px;
        line-height:104px;
        text-align:center;
        font-weight:600;
        position:relative;
        .help_tips{
            position:absolute;
            top:14px;
            right:14px;
            min-width: 137px;
            height: 36px;
            line-height:36px;
            background: #EBFBF8;
            border-radius: 100px;
            font-size:16px;
            color:#00C4A1;
            text-align:center;
            cursor:pointer;
            font-weight:400;
            i{
                font-size:16px;
                padding-right:5px;
                color:#00C4A1;
            }
        }
    }
</style>
<template>
    <div class="stepHeader">
        <div class="stepHeaderTop">
            <div class="stepHeaderInner">
                <div class="stepColumn">
                    <div v-for="(item,index) in arr_step" :key="index" :class="{active:index == stepIndex}" @click="jumpToStep(index)">
                        <div :class="['icon',item.icon,{active:index == stepIndex}]"></div>
                        <p :class="{active:index == stepIndex}">{{item.txt}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "step",
    props: {
        stepIndex:{
            type: Number,
            default: 0,
        },
        arr_step: {
            type: Array,
            default: () => [
                {
                    icon:"step1",
                    txt:'基础信息',
                    path:'/initiate/idea'
                },
                {
                    icon:"step4",
                    txt:'首次更新',
                    path:'/initiate/idea_update'
                }
            ],
        },
    },
    components: {

    },
    data() {
        return {
            cpoperator:[],
            qrcodeIsShow:false,
            qrcode_url:'',
        };
    },
    computed: {

    },
    created() {
        
    },
    mounted(){
        this.$nextTick(()=>{ 
            
        })
    },
    methods: {
        jumpToStep(index){
            if(this.stepIndex == index){
                return false;
            }
            this.$emit('stepChange',index)
        }
    }
};
</script>